import { buildHomeBandWeightAndColor, ISelectWeight, IWizardStep } from 'fitbeat.gym-core';
import React from 'react';
import { connect } from 'react-redux';
import { answerStrenghtAssessment } from './actions';
import { SelectWeight } from './SelectWeight';

interface IDispatchProps {
  selectWeight(
    index: number,
    currentStep: IWizardStep<ISelectWeight>,
  ): void;
}
interface IOwnProps {
  currentStep: IWizardStep<ISelectWeight>;
}

type IProps = IDispatchProps & IOwnProps;

export const SelectBandWeightComponent: React.FunctionComponent<IProps> = ({
  currentStep,
  selectWeight,
}) => {
  return (
    <SelectWeight
      selectWeight={selectWeight}
      getWeightAndColor={(equipmentWeight) =>
        buildHomeBandWeightAndColor(equipmentWeight)
      }
      currentStep={currentStep}
      isSelected={(index: number, answer: number) => {
        return index + 1 === answer;
      }}
    />
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    selectWeight: (index: number, currentStep) =>
      dispatch(answerStrenghtAssessment(index + 1, currentStep)),
  };
};

export const SelectBandWeight: React.FC<IOwnProps> = connect(
  null,
  mapDispatchToProps,
)(SelectBandWeightComponent);
